module.exports = __webpack_public_path__ + "static/media/plans-active.b59a6511.svg";